import { Button, Tabbar, TabbarItem, List, Cell, Search, FloatingBubble, Form, Field, Uploader, Popup, Image as VanImage, Icon, NavBar, DatetimePicker, Calendar, CellGroup, Grid, GridItem, Empty, Toast as VanToast, Dialog, SwipeCell, Picker, Progress, ActionSheet, Tabs, Tab, PullRefresh, Tag, Skeleton, Sticky } from 'vant'

const components = [
  Button,
  Tabbar,
  TabbarItem,
  List,
  Cell,
  Search,
  FloatingBubble,
  Form,
  Field,
  Uploader,
  Popup,
  DatetimePicker,
  Calendar,
  CellGroup,
  Grid,
  GridItem,
  Empty,
  VanImage,
  Icon,
  NavBar,
  VanToast,
  Dialog,
  SwipeCell,
  Picker,
  Progress
  , ActionSheet, Tabs, Tab, PullRefresh
  , Tag, Skeleton, Sticky
]

/**
 * 批量注册 Vant 组件
 * @param {import('vue').App} app
 */
export function setupVant(app) {
  components.forEach(comp => app.use(comp))
} 